var styles = {"badges":"index-module_badges__hkNu4"};

export { styles as default };
//# sourceMappingURL=index.module.css.js.map
